import { PersonnelUsersUIProvider } from "./PersonnelUsersUIContext";
import { PersonnelUsersCard } from "./PersonnelUsersCard";

export function PersonnelUsersPage({
  history,
  userGroupId,  
  userType
}) {
  return (
    <PersonnelUsersUIProvider>
      <PersonnelUsersCard
        history={history}
        userGroupId={userGroupId}        
        userType={userType}
      />
    </PersonnelUsersUIProvider>
 );
}